export enum ModalsActionTypes {
  SET_CURRENT_TYPE = 'Modals/SET_CURRENT_TYPE',
  SET_SELECTED_SHOPPING_CART_ROWS = 'Modals/SET_SELECTED_SHOPPING_CART_ROWS',
}
